import { useMemo } from 'react';
import { getColorValue } from '@shinetools/sunshine';
import { Rectangle } from 'recharts';

const GraphCursor = ({ ...props }) => {
  const { allowedDataKeys = null, height, payload, points } = props;

  const shouldDisplay = useMemo(() => {
    const hasPayload = payload?.find(
      (p: { value: number | null }) => p.value !== null,
    );

    // Do not display the cursor if there are no values
    if (!hasPayload) {
      return false;
    }

    if (!allowedDataKeys) {
      return true;
    }

    return allowedDataKeys.includes(hasPayload.dataKey);
  }, [payload, allowedDataKeys]);

  if (!shouldDisplay) {
    return null;
  }

  let x = 0;
  if (points && points[0].x) {
    x = points[0].x;
  }

  return (
    <Rectangle
      height={height}
      stroke={getColorValue('grey.300')}
      width={0.5}
      x={x}
      y={5}
    />
  );
};

export default GraphCursor;
